import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Alert, Col, Input, Modal, Row } from 'antd'
import { isEmpty } from 'lodash'
import http from '../../utils/api'
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const AddEditBoothModal = ({
  visible,
  handleOk,
  handleCancel,
  companyBooth,
  fieldName = '',
}) => {
  const [data, setData] = useState(companyBooth)
  const [errorMessage, setErrorMessage] = useState('')

  const updateData = (field, value) => {
    if (isEmpty(fieldName)) {
      const newState = { ...data }
      newState[field] = value
      setData(newState)
    } else {
      const newState = { ...data }
      const splitField = field.split('.')
      newState[splitField[0]][splitField[1]] = value
      setData(newState)
    }
  }

  const saveChanges = () => {
    http
      .put(`/events/${data.eventId}/booth`, data)
      .then((response) => {
        handleOk(data)
      })
      .catch((error) => {
        if (error.response) {
          const message =
            error.response.data?.message ||
            error.response.data ||
            'Došlo je do greške.'

          setErrorMessage(message)
        } else {
          setErrorMessage('Neuspjela komunikacija sa serverom.')
        }
      })
  }

  const onClose = () => {
    setData(companyBooth)
    handleCancel()
  }

  return (
    <Modal
      className="cc-modal-accept"
      title={isEmpty(fieldName) ? `Edit Booth` : ``}
      visible={visible}
      okText={`Save Changes`}
      cancelText="Close"
      onOk={saveChanges}
      onCancel={onClose}
      okButtonProps={{
        disabled: false,
        style: { backgroundColor: '#2FC5D2', borderStyle: 'none' },
      }}
      centered={true}
      cancelButtonProps={{ disabled: false }}
    >
      <div>
        {errorMessage && (
          <Alert
            message={errorMessage}
            type="warning"
            icon={
              <FontAwesomeIcon color="#F19F00" icon={faExclamationCircle} />
            }
            showIcon
            style={{ marginBottom: '20px' }}
          />
        )}
        <div>
          <Row>
            <Col span={24}>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: '18px',
                  paddingBottom: '8px',
                }}
              >
                {isEmpty(fieldName) ? `Edit Booth Name` : ``}
              </div>
            </Col>
            <Col span={24}>
              <Input
                autoSize={{ minRows: 1, maxRows: 1 }}
                value={data.boothName}
                onChange={(e) => {
                  updateData('boothName', e.target.value)
                }}
              />
            </Col>
          </Row>
        </div>
      </div>
    </Modal>
  )
}

AddEditBoothModal.GeneralInfoModal = {
  visible: PropTypes.bool.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  companyBooth: PropTypes.object.isRequired,
  fieldName: PropTypes.string,
}

export default AddEditBoothModal
